export type GouvernancePrisme2TaskRow = {
  objectifs_macro: string;
  besoins_specifique: string;
  sto: string;
  axe_pilier: string;
  thp: string;
  priorite: string;
  a: string;
  r: string;
  c: string;
  i: string;
  date_debut: string;
  date_validation: string;
  date_finale: string;
  coordination: string;
  description: string;
};

export type GouvernancePrisme2TasksPayload = {
  canEdit: boolean;
  rows: GouvernancePrisme2TaskRow[];
  updated_at?: string;
  updated_by_email?: string;
};

// Utiliser /api/serq/... (route réelle Express). Le préfixe /api/prisme/* est réécrit côté serveur,
// mais selon l’ordre des middlewares / le cache d’URL, ce chemin direct évite les 404 en dev (proxy Vite).
const API_URL = '/api/serq/gouvernance/prisme-2/tasks';

export async function getGouvernancePrisme2Tasks(): Promise<GouvernancePrisme2TasksPayload> {
  const res = await fetch(API_URL, { credentials: 'include' });
  if (!res.ok) throw new Error('Erreur chargement Tableau des tâches (Gouvernance PRIsME 2.0)');
  return await res.json();
}

export async function saveGouvernancePrisme2Tasks(rows: GouvernancePrisme2TaskRow[]): Promise<GouvernancePrisme2TasksPayload> {
  const res = await fetch(API_URL, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ rows }),
  });
  if (!res.ok) throw new Error('Erreur sauvegarde Tableau des tâches (Gouvernance PRIsME 2.0)');
  return await res.json();
}

